import { vehicleDocsSchema } from "styles/types/vehicle";
import docClient from "../../services/httpClient/documentClient";
import { CorporateDocuments, ProfileImage } from "./models";

export const getDocumentTypes = () => docClient.get("/api/Document/types");

export const getFileTypes = () => docClient.get("/api/Document/file-types");

export const uploadDocument = (payload: ProfileImage) =>
  docClient.post("/api/Document/upload", payload);

export const getDocument = () => docClient.get("/api/Document");

export const getDocumentById = (id: string) =>
  docClient.get(`/api/Document/${id}`);

export const getVehicleDocsType = () => {
  return docClient.get("/api/Document/get-vf-document-types");
};

export const uploadVehicleDocs = (payload: vehicleDocsSchema,config:any) => {
  return docClient.put("/api/Document/vehicle-finance-document", payload,config);
};

export const getVehicleDocuments = () => {
  return docClient.get("/api/Document/get-vehicle-finance-documents");
};
export const getStates = () => docClient.get(`/api/States`);

export const getLgasByState = (stateName: string) =>
  docClient.get(`/api/States/${stateName}/lgas`);

export const getCorporateDocuments = () =>
  docClient.get<CorporateDocuments>(`/api/Document/get-corporate-documents`);

export const getDownloadTemplate = (documentype: string) =>
  docClient.get(`/api/Document/download-template/${documentype}`);

export const getCorporateIdTypes = () =>
  docClient.get("/api/Document/id-types");

export const submitCorporateDocuments = () =>
  docClient.post("/api/Document/submit-corporate-document");

export const uploadCorporateDocument = (payload: any, config: any) =>
  docClient.put("/api/Document/corporate-document", payload, config);

export const submitVehicleDocuments = () =>
  docClient.post("/api/Document/submit-vehicle-finance-document");

export const getDocumentStatus = () =>
  docClient.get("/api/Document/status");
